import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { type Patient } from '@avanta/shared/types/patients';

export const useUpdatePatient = (showToast = true): UseMutationResult<void, Error, Patient> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  return useMutation<void, Error, Patient>({
    mutationKey: [MUTATION_KEYS.UPDATE_PATIENT],
    mutationFn: async (patient: Patient) => {
      await PatientService.updatePatient(patient);
    },
    onSuccess: (_, patient) => {
      const newPatient = { ...patient, requiredProfileSetup: false };
      queryClient.setQueryData([QUERY_KEYS.FETCH_PATIENT], () => ({
        data: newPatient,
      }));
      if (showToast) {
        toast.success(t('SignupForm.update.success'));
      }
    },
  });
};
